import { render, staticRenderFns } from "./segment-header-loader.vue?vue&type=template&id=50ac7292"
import script from "./segment-header-loader.vue?vue&type=script&lang=js"
export * from "./segment-header-loader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports